/* global theme, pinCampaignModalStrings, pinCampaignFormStrings */

import {
  prizeQuantityFields,
  prizeSelectRemaining,
  pinForm,
  pinFormSubmit,
  provinceOfResidenceField,
  maxPins,
  customPrizeContainers,
  pinCountMessaging,
  selectors,
  klaviyo,
  modal,
  errorHandling,
  pinManagement,
  requestPin,
} from './global.js';

import { utils } from './utils.js';

// Shared instance of AddressValidation
import addressValidation from './classes/address-validation.js';

/*==========================================================================
  CACHE DOM
============================================================================*/
var dateOfBirthField = document.getElementById('date-of-birth');
var emailField = document.getElementById('email');
var firstNameField = document.getElementById('first-name');
var lastNameField = document.getElementById('last-name');
var pinCountTotal = document.querySelectorAll('.js-pin-count-total');
var pinCountWinning = document.querySelectorAll('.js-pin-count-winning');
var skillTest = document.getElementById('skill-test');
var sorryMessage = document.getElementById('sorry-message');
var pageContentCampaignForm = document.getElementById(
  'page-content-campaign-form'
);
var pageContentPrizeSelection = document.getElementById(
  'page-content-prize-selection'
);
var pageContentLoser = document.getElementById('page-content-loser');
var pageContentWinner = document.getElementById('page-content-winner');
var $pinEntryField = theme.jQuery(selectors.pinEntryField);
var $pinEntryContainer = theme.jQuery('.pin-entry-container');

var entryId = null;

/*==========================================================================
    VALIDATION
  ============================================================================*/
export function validateAll() {
  errorHandling.showErrorMessages();

  validateUserData();

  klaviyo.identifyUser();

  if (errorHandling.state.visualErrorCount == 0) {
    // NO VISUAL ERRORS (may still be hidden errors though, will check later)
    // user data is valid

    // hide sorry message
    sorryMessage.style.display = 'none';

    // loading, block submit button
    pinFormSubmit.disabled = true;

    if (errorHandling.getHiddenErrorCount() === 0) {
      // These will be sent to the app and Klaviyo
      validatePins();
    } else {
      /**
       * Track in Klaviyo, without hitting the app. A lot of this logic is very
       * similar to what happens inside the success callback of the app verify
       * request. We should aim to combine the functionality somehow.
       */

      // TODO: consider making this part of the pinManagement class
      var pinsForKlaviyo = [];
      var customPropertyDescription = ' (PIN__Date';

      klaviyo.eventDataArray = [];

      // get all PINs, even though they won't hit the app on this path
      pinManagement.updateEnteredPinsArray();

      var hasDateOfBirthField = false;
      var hasSkillTest = false;

      // only exists on Michelob Celebrate your Steps
      var steps = document.querySelector('#steps');

      for (var i = 0; i < pinManagement.enteredPinsArray.length; i++) {
        var pin = pinManagement.enteredPinsArray[i];

        var now = new Date();
        var nowFormatted =
          now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
        // pinsForKlaviyo.push(pin);
        pinsForKlaviyo.push(
          pin +
            (nowFormatted ? '__' + nowFormatted : '') +
            (dateOfBirthField ? '__' + dateOfBirthField.value : '') +
            (skillTest ? '__' + skillTest.value : '')
        );

        if (dateOfBirthField) {
          hasDateOfBirthField = true;
        }

        if (skillTest) {
          hasSkillTest = true;
        }

        klaviyo.eventDataArray.push({});
        var eventData = klaviyo.eventDataArray[i];

        // specific to household limits, but including them regardless for consistency
        if (addressValidation) {
          if (addressValidation.userAddress.address1) {
            klaviyo.eventDataArray[i]['Address1'] =
              addressValidation.userAddress.address1;
          }

          if (addressValidation.userAddress.address2) {
            klaviyo.eventDataArray[i]['Address2'] =
              addressValidation.userAddress.address2;
          }

          if (addressValidation.userAddress.city) {
            klaviyo.eventDataArray[i]['City'] =
              addressValidation.userAddress.city;
          }

          if (addressValidation.userAddress.province) {
            klaviyo.eventDataArray[i]['Province'] =
              addressValidation.userAddress.province;
          }

          if (addressValidation.userAddress.zip) {
            klaviyo.eventDataArray[i]['Zip'] =
              addressValidation.userAddress.zip;
          }

          if (addressValidation.userAddress.country_code) {
            klaviyo.eventDataArray[i]['Country'] =
              addressValidation.userAddress.country_code;
          }
        }

        if (requestPin && requestPin.phone) {
          klaviyo.eventDataArray[i]['Phone'] = requestPin.phone;
        }
        if (requestPin && requestPin.pinRequestId) {
          klaviyo.eventDataArray[i]['PIN Request ID'] = requestPin.pinRequestId;
        }
        klaviyo.eventDataArray[i]['Province of Residence'] =
          provinceOfResidenceField ? provinceOfResidenceField.value : '';
        klaviyo.eventDataArray[i]['PIN Campaign'] =
          pinForm.dataset.campaignName;
        klaviyo.eventDataArray[i][
          'Skill Test [' + pinForm.dataset.skillTestQuestion + ']'
        ] = skillTest ? skillTest.value : '';
        klaviyo.eventDataArray[i]['Date of Birth'] = dateOfBirthField
          ? dateOfBirthField.value
          : '';
        klaviyo.eventDataArray[i]['Of Age'] = dateOfBirthField
          ? utils.isAgeValid(dateOfBirthField.value)
          : '';
        klaviyo.eventDataArray[i]['Cause of error'] =
          errorHandling.getKlaviyoErrorString();
        klaviyo.eventDataArray[i]['PIN'] = pin ? pin : '';
        klaviyo.eventDataArray[i]['Status'] = 'validation error';

        // Required to create unique events when submitting multiples at once
        klaviyo.eventDataArray[i]['$event_id'] = pin ? Date.now() + pin : '';

        // if steps exists, track it with the event
        if (steps) {
          klaviyo.eventDataArray[i]['Steps'] = steps.value;
        }

        var eventName = 'PIN Submitted';

        klaviyo.trackEvent(eventName, eventData);
      }

      if (hasDateOfBirthField) {
        customPropertyDescription += '__DOB';
      }

      if (hasSkillTest) {
        customPropertyDescription += '__Skill-Answer';
      }

      // close the string
      customPropertyDescription += ')';

      // push the entered PINs to customer properties so the client can count how many have been entered.
      klaviyo.appendCustomProperty(
        pinForm.dataset.campaignName + customPropertyDescription,
        pinsForKlaviyo
      );

      // IF DRAW ONLY
      if (utils.isDraw()) {
        // subscribe users to draw list in Klaviyo
        klaviyo.subcribeToList();
      }

      // fail without hitting the app, regardless of PIN states
      showWinOrLose(false);
    }
  } else {
    // VISUAL ERRORS
    // user data is invalid
    // allow users to fix errors and re-submit
    pinFormSubmit.disabled = false;

    /**
     * If there are visual errors, we want to give users a chance to fix them
     */
  }
}

/**
 * validateuserData - check email, DOB and skill tests for validity
 */
function validateUserData() {
  // validate email
  if (
    errorHandling.state.visualValidity['email'].valid &&
    errorHandling.state.visualValidity['email-confirmation'].valid
  ) {
    // init/re-init Klaviyo class every time user data is validated
    klaviyo.init(emailField.value, firstNameField.value, lastNameField.value);

    // Pass contact info to checkout too
    localStorage.userData = JSON.stringify({
      first_name: firstNameField.value,
      last_name: lastNameField.value,
      email: emailField.value,
    });
  }
}

function validatePins() {
  // reset pinManagement.winningPinsArray
  pinManagement.winningPinsArray = [];
  klaviyo.eventDataArray = [];

  pinManagement.updateEnteredPinsArray();

  var formUrl = pinForm.dataset.action,
    ineligiblePins = [];

  // update $pinEntryField so that index based error messages are accurate
  // if any blanks have been removed.
  $pinEntryField = theme.jQuery(selectors.pinEntryField);

  // remove error/success highlighting
  $pinEntryField.removeClass('errors note--success');

  theme.jQuery('.pin-entry-error').remove();

  // check if the last field has an add button. if not, append it
  if (!$pinEntryField.parent().last().find(selectors.pinEntryAdd).length) {
    // if we're not maxed out already
    if (pinManagement.pinEntryGroupCount < maxPins) {
      $pinEntryField
        .parent()
        .last()
        .append(
          '<div class="pin-entry-add"><button type="button" class="pin-entry-add-button">+</button></span>'
        );
    }
  }

  // submit all PINs to find any issues
  pinManagement.getPinsInCart().then(function () {
    const appData = {
      ids: pinManagement.enteredPinsArray,
      email: emailField.value,
      referrer: document.referrer,

      pin_request_id: requestPin.pinRequestId,
      phone: requestPin.phone,

      first_name: firstNameField ? firstNameField.value : null,
      last_name: lastNameField ? lastNameField.value : null,

      // specific to contests, but including them regardless for consistency
      skill_answer: skillTest ? skillTest.value : null,
      dob: dateOfBirthField ? dateOfBirthField.value : null,

      // specific to household limits, but including them regardless for consistency
      address1:
        addressValidation && addressValidation.userAddress.address1
          ? addressValidation.userAddress.address1
          : null,
      address2:
        addressValidation && addressValidation.userAddress.address2
          ? addressValidation.userAddress.address2
          : null,
      city:
        addressValidation && addressValidation.userAddress.city
          ? addressValidation.userAddress.city
          : null,
      province_code:
        addressValidation && addressValidation.userAddress.province
          ? addressValidation.userAddress.province
          : null,
      zip:
        addressValidation && addressValidation.userAddress.zip
          ? addressValidation.userAddress.zip
          : null,
      country_code: 'CA',
    };

    // POST entered PINs to PIN Campaign App
    theme.jQuery
      .ajax({
        type: 'POST',
        url: formUrl,
        data: JSON.stringify(appData),
        success: function (data) {
          if (addressValidation) {
            addressValidation.storeUserAddress();
          }

          /**
           * Track in Klaviyo, AFTER hitting the app. A lot of this logic is
           * very similar to what happens above, if there are hidden errors. We
           * should aim to combine the functionality somehow.
           */

          // TODO: consider making this part of the pinManagement class
          var pinsForKlaviyo = [];
          var customPropertyDescription = ' (PIN__Date';

          if (window.tdTracker && typeof window.tdTracker === 'object') {
            window.tdTracker.trackFormSubmit(pinForm);
          }

          var hasDateOfBirthField = false;
          var hasSkillTest = false;

          // only exists on Michelob Celebrate your Steps
          var steps = document.querySelector('#steps');

          let pins;
          let householdLimitEnforced;
          if (utils.hasHouseholdLimit()) {
            // Set global entryId var
            entryId = data.entry_id;
            pins = data.pins;
            householdLimitEnforced = data.household_limit_enforced;
          } else {
            pins = data;
          }

          // check for invalid or redeemed PINs
          for (var i = 0; i < pins.length; i++) {
            var pinResponse = pins[i];

            var now = new Date();
            var nowFormatted =
              now.getFullYear() +
              '-' +
              (now.getMonth() + 1) +
              '-' +
              now.getDate();

            pinsForKlaviyo.push(
              pinResponse.id +
                (nowFormatted ? '__' + nowFormatted : '') +
                (dateOfBirthField ? '__' + dateOfBirthField.value : '') +
                (skillTest ? '__' + skillTest.value : '')
            );

            // add an empty object then fill it
            klaviyo.eventDataArray.push({});

            // BEGIN properties shared between the app and Klaviyo
            if (appData.phone) {
              klaviyo.eventDataArray[i]['Phone'] = appData.phone;
            }

            if (appData.pinRequestId) {
              klaviyo.eventDataArray[i]['PIN Request ID'] =
                appData.pinRequestId;
            }

            if (appData.dob) {
              klaviyo.eventDataArray[i]['Date of Birth'] = appData.dob;
            }

            if (appData.address1) {
              klaviyo.eventDataArray[i]['Address1'] = appData.address1;
            }

            if (appData.address2) {
              klaviyo.eventDataArray[i]['Address2'] = appData.address2;
            }

            if (appData.city) {
              klaviyo.eventDataArray[i]['City'] = appData.city;
            }

            if (appData.province_code) {
              klaviyo.eventDataArray[i]['Province'] = appData.province_code;
            }

            if (appData.zip) {
              klaviyo.eventDataArray[i]['Zip'] = appData.zip;
            }

            if (appData.country_code) {
              klaviyo.eventDataArray[i]['Country'] = appData.country_code;
            }
            // END properties shared between the app and Klaviyo

            // BEGIN properties specific to Klaviyo
            klaviyo.eventDataArray[i]['PIN Campaign'] =
              pinForm.dataset.campaignName;

            // Required to create unique events when submitting multiples at once
            klaviyo.eventDataArray[i]['$event_id'] = pinResponse
              ? Date.now() + pinResponse.id
              : '';

            if (entryId) {
              klaviyo.eventDataArray[i]['Entry ID'] = entryId;
            }

            if (errorHandling.getHiddenErrorCount() > 0) {
              klaviyo.eventDataArray[i]['Cause of error'] =
                errorHandling.getKlaviyoErrorString();
            }

            if (utils.isContest()) {
              klaviyo.eventDataArray[i][
                'Skill Test [' + pinForm.dataset.skillTestQuestion + ']'
              ] = skillTest ? skillTest.value : '';

              klaviyo.eventDataArray[i]['Of Age'] = dateOfBirthField
                ? utils.isAgeValid(dateOfBirthField.value)
                : '';

              klaviyo.eventDataArray[i]['Province of Residence'] =
                provinceOfResidenceField ? provinceOfResidenceField.value : '';

              if (dateOfBirthField) {
                hasDateOfBirthField = true;
              }

              if (skillTest) {
                hasSkillTest = true;
              }

              // if steps exists, track it with the event
              if (steps) {
                klaviyo.eventDataArray[i]['Steps'] = steps.value;
              }
            }
            // END properties specific to Klaviyo

            /**
             * possible status codes:
             *
             * won:
             *   this could be a possible outcome for any campaign.
             *
             * lost:
             *   this should only be a possible outcome for “contest”
             *   campaigns where the probability of winning is less than 1.
             *   UPDATE: This status is now achievable if the customer has
             *   exceeded the household prize limit
             *
             * redeemed:
             *   this will be returned when the pin has already been used to
             *   order a product. Before the order is complete the "won" state
             *   will be returned instead. Note that no pins will return this
             *   state for now - the system to track redemption has not been
             *   implemented yet.
             *
             * invalid:
             *   this state should only be returned if the pin could not be
             *   found in the database.
             */

            // if PIN is already in cart, mark it as such
            if (pinManagement.pinsInCart.indexOf(pinResponse.id) > -1) {
              theme
                .jQuery($pinEntryField[i])
                .addClass('errors')
                .parent()
                .append(
                  '<small class="pin-entry-error">' +
                    unescape(pinCampaignFormStrings.strings.pinInCart) +
                    '</small>'
                );
              ineligiblePins.push(pinResponse.id);
              continue;
            }

            // if PIN is already in form, mark it as such
            if (pinManagement.enteredPinsArray.indexOf(pinResponse.id) !== i) {
              theme
                .jQuery($pinEntryField[i])
                .addClass('errors')
                .parent()
                .append(
                  '<small class="pin-entry-error">' +
                    unescape(pinCampaignFormStrings.strings.pinInForm) +
                    '</small>'
                );
              ineligiblePins.push(pinResponse.id);
              continue;
            }

            if (utils.isTestMode()) {
              if (pinResponse.id.indexOf('TEST') > -1) {
                pinManagement.winningPinsArray.push(pinResponse.id);

                // highlight legitimate PINs
                // $($pinEntryField[i]).addClass('note--success');

                // track PIN against user profile in Klaviyo
                klaviyo.eventDataArray[i]['PIN'] = pinResponse.id;
                klaviyo.eventDataArray[i]['Status'] = 'test';
                continue;
              }

              if (pinResponse.id.indexOf('LOSE') > -1) {
                // track PIN against user profile in Klaviyo
                klaviyo.eventDataArray[i]['PIN'] = pinResponse.id;
                klaviyo.eventDataArray[i]['Status'] = 'test-lost';

                if (householdLimitEnforced) {
                  klaviyo.eventDataArray[i]['Household Limit Enforced'] =
                    householdLimitEnforced;
                }

                continue;
              }
            }

            if (utils.isPinBypassMode()) {
              if (pinResponse.id.indexOf('NOPIN') > -1) {
                pinManagement.winningPinsArray.push(pinResponse.id);

                // highlight legitimate PINs
                // $($pinEntryField[i]).addClass('note--success');

                // track PIN against user profile in Klaviyo
                klaviyo.eventDataArray[i]['PIN'] = pinResponse.id;
                klaviyo.eventDataArray[i]['Status'] = 'won';
                continue;
              }
            }

            if (pinResponse.state == 'redeemed') {
              theme
                .jQuery($pinEntryField[i])
                .addClass('errors')
                .parent()
                .append(
                  '<small class="pin-entry-error">' +
                    unescape(
                      pinCampaignFormStrings.strings.pinAlreadyRedeemed
                    ) +
                    '</small>'
                );
              ineligiblePins.push(pinResponse.id);
              continue;
            }

            if (pinResponse.state == 'invalid') {
              theme
                .jQuery($pinEntryField[i])
                .addClass('errors')
                .parent()
                .append(
                  '<small class="pin-entry-error">' +
                    unescape(pinCampaignFormStrings.strings.pinInvalid) +
                    '</small>'
                );
              ineligiblePins.push(pinResponse.id);
              continue;
            }

            if (pinResponse.state == 'won') {
              pinManagement.winningPinsArray.push(pinResponse.id);

              // highlight legitimate PINs
              // $($pinEntryField[i]).addClass('note--success');

              // track PIN against user profile in Klaviyo
              klaviyo.eventDataArray[i]['PIN'] = pinResponse.id;
              klaviyo.eventDataArray[i]['Status'] = pinResponse.state;
              continue;
            }

            if (pinResponse.state == 'lost') {
              // highlight legitimate PINs
              // $($pinEntryField[i]).addClass('note--success');

              // track PIN against user profile in Klaviyo
              klaviyo.eventDataArray[i]['PIN'] = pinResponse.id;
              klaviyo.eventDataArray[i]['Status'] = pinResponse.state;

              if (householdLimitEnforced) {
                klaviyo.eventDataArray[i]['Household Limit Enforced'] =
                  householdLimitEnforced;
              }

              continue;
            }
          }

          if (ineligiblePins.length > 0) {
            // don't move forward
            // allow users to fix PIN errors
            pinFormSubmit.disabled = false;
          } else {
            // move forward with win or lose pages
            // track winning and losing PINs as events in Klaviyo
            for (var i = 0; i < klaviyo.eventDataArray.length; i++) {
              var eventData = klaviyo.eventDataArray[i];
              var eventName = 'PIN Submitted';

              klaviyo.trackEvent(eventName, eventData);
            }

            // qwertyuiop
            if (hasDateOfBirthField) {
              customPropertyDescription += '__DOB';
            }

            if (hasSkillTest) {
              customPropertyDescription += '__Skill-Answer';
            }

            // close the string
            customPropertyDescription += ')';

            // push the entered PINs to customer properties so the client can count how many have been entered.
            klaviyo.appendCustomProperty(
              pinForm.dataset.campaignName + customPropertyDescription,
              pinsForKlaviyo
            );

            // winner
            if (
              !!pinManagement.winningPinsArray.length &&
              errorHandling.getHiddenErrorCount() === 0
            ) {
              // update messaging on winning pages
              for (var i = 0; i < pinCountMessaging.length; i++) {
                pinCountMessaging[i].style.display = 'block';
              }

              for (var i = 0; i < pinCountWinning.length; i++) {
                pinCountWinning[i].innerHTML =
                  pinManagement.winningPinsArray.length;
              }

              for (var i = 0; i < pinCountTotal.length; i++) {
                pinCountTotal[i].innerHTML =
                  pinManagement.enteredPinsArray.length;
              }

              if (utils.isDraw()) {
                // reset the winning PINs array
                pinManagement.winningPinsArray = [];

                // subscribe users to draw list in Klaviyo. this list will later be segmented into just winners
                klaviyo.subcribeToList();

                // show winner page
                showWinOrLose(true);
              } else {
                // user selects prizes
                if (utils.isUserSelection()) {
                  // update visible prize count
                  for (var i = 0; i < prizeSelectRemaining.length; i++) {
                    prizeSelectRemaining[i].innerHTML =
                      pinManagement.winningPinsArray.length;
                  }

                  // render selection interface
                  showPrizeSelection();

                  // random prize assignment
                } else {
                  // add the prizes to the cart
                  theme.cart
                    .addItemFromForm({
                      items: getRandomPrizes(pinManagement.winningPinsArray),
                    })
                    .then(function () {
                      theme.jQuery('body').trigger('added.ajaxProduct');
                      klaviyo.trackEvent('Prize(s) added to cart');
                    });

                  // reset the winning PINs array
                  pinManagement.winningPinsArray = [];

                  // show winner page
                  showWinOrLose(true);
                }
              }

              // loser
            } else {
              if (utils.isDraw()) {
                // subscribe users to draw list in Klaviyo. this list will later be segmented into jsut winners
                klaviyo.subcribeToList();
              }

              if (utils.isContest()) {
                // show loser page
                showWinOrLose(false);
              } else {
                // show loser message
                sorryMessage.style.display = 'block';

                // done, unblock submit button
                pinFormSubmit.disabled = false;
              }
            }
          }
        },
        headers: { 'Content-Type': 'application/json' },
      })
      .fail(function (response) {
        let errorMessage = theme.campaignData.strings.genericError;

        if (response.status === 422) {
          errorMessage = '';

          for (const property in response.responseJSON.errors) {
            if (property.toLowerCase().includes('recaptcha')) {
              errorMessage = `${theme.campaignData.strings.recaptcha}<br>${errorMessage}`;
            } else {
              // dynamically generate any additional error messages
              errorMessage = `${property}: ${response.responseJSON.errors[property]}<br>${errorMessage}`;
            }
          }
        }

        modal.updateMessage(unescape(errorMessage));
        modal.open();

        pinFormSubmit.disabled = false;
      });
  });
}

/*==========================================================================
    RENDERING
  ============================================================================*/
export function showWinOrLose(winner) {
  // hide PIN form
  pageContentCampaignForm.style.display = 'none';

  // hide prize selection interface
  pageContentPrizeSelection.style.display = 'none';

  if (winner) {
    // show winning "page"
    pageContentWinner.style.display = 'block';
  } else {
    // show losing "page"
    pageContentLoser.style.display = 'block';
  }

  // Scroll to top of page
  theme.jQuery('html,body').scrollTop(0);
}

function showPrizeSelection() {
  // hide PIN form
  pageContentCampaignForm.style.display = 'none';

  // show prize selection interface
  pageContentPrizeSelection.style.display = 'block';

  // Scroll to top of page
  theme.jQuery('html,body').scrollTop(0);
}

export function addPinFields(addButtonEl) {
  if (pinManagement.pinEntryGroupCount < maxPins) {
    // create clone
    var $parentClone = theme.jQuery(addButtonEl).parent().clone(),
      $pinEntryField = $parentClone.find(selectors.pinEntryField),
      $pinEntryError = $parentClone.find(selectors.pinEntryError);

    // remove clone's required attr and empty the input
    $pinEntryField
      .removeClass('errors note--success')
      .removeAttr('required')
      .val('');

    // remove clone's errors
    $pinEntryError.remove();

    $pinEntryContainer.append($parentClone);

    $pinEntryField.focus();

    // increment state
    pinManagement.pinEntryGroupCount = pinManagement.pinEntryGroupCount + 1;
  }
}

export function removePinField(removeButtonEl) {
  if (pinManagement.pinEntryGroupCount > 1) {
    theme.jQuery(removeButtonEl).parents('.pin-entry-group').remove();

    // decrement state
    pinManagement.pinEntryGroupCount = pinManagement.pinEntryGroupCount - 1;
  }
}

/*==========================================================================
    WINNING ACTIONS
  ============================================================================*/
function buildPrizesArray(arrayName, id, properties) {
  // Add more properties
  properties._eligible_provinces = utils.getEligibleProvinces();
  properties._has_household_limit = utils.hasHouseholdLimit();
  if (entryId) {
    properties._entry_id = entryId;
  }

  arrayName.push({
    quantity: 1,
    id: id,
    properties: properties,
  });
}

/**
 * getWeightedRandomPrizeIndex - uses remaining inventory to weight the odds of receiving a product. The lower the inventory, the less likely it is that a user will receive the product. If inventory is 0, users can not win that prize.
 *
 * @return {number} the index position of the winning prize in theme.prizeItems array
 */
function getWeightedRandomPrizeIndex() {
  var i,
    sum = 0,
    random = Math.random();

  for (i in theme.prizeItems) {
    sum += theme.prizeItems[i].inventory_weighted_odds;

    if (random <= sum) {
      return Number(i);
    }
  }
}

/**
 * updateInventoryWeightedOdds - adjusts the inventory weighted odds after decrementing prize product's inventory_quantity
 */
function updateInventoryWeightedOdds() {
  var totalPrizeQty = 0;

  for (i in theme.prizeItems) {
    totalPrizeQty += theme.prizeItems[i].inventory_quantity;
  }

  for (i in theme.prizeItems) {
    theme.prizeItems[i].inventory_weighted_odds =
      theme.prizeItems[i].inventory_quantity / totalPrizeQty;
  }
}

/**
 * getRandomPrizes - will randomly create an object of X prizes, each with a
 * unique PIN attached to it as a line item property
 *
 * * Uses array 'pinManagement.winningPinsArray'
 *
 * @return {object} product object for ajax call
 */
function getRandomPrizes() {
  var prizeItemsData = [];

  // for each winning pin
  for (var i = 0; i < pinManagement.winningPinsArray.length; i++) {
    var winningPin = pinManagement.winningPinsArray[i];
    var randomPrizeIndex = getWeightedRandomPrizeIndex();

    buildPrizesArray(
      prizeItemsData,
      theme.prizeItems[randomPrizeIndex].variant_id,
      { pin: winningPin }
    );

    // update inventory_quantity of theme.prizeItems to reflect
    // what we are about to add to the cart. this prevents us
    // from adding more products than the shop has in stock
    theme.prizeItems[randomPrizeIndex].inventory_quantity =
      theme.prizeItems[randomPrizeIndex].inventory_quantity - 1;

    updateInventoryWeightedOdds();
  }

  return prizeItemsData;
}

/**
 * getSelectPrizes - build one object to pass to Shopify's AJAX API, to add
 * user selected prize product(s) to the cart. Also attaches a unique line
 * item property to the product, which will be one of the winning PINs entered.
 *
 * Uses array 'pinManagement.winningPinsArray'.
 *
 * @return {array} an array of product objects
 */
export function getSelectPrizes(
  customLineItemOnePropertiesArray,
  customLineItemTwoPropertiesArray
) {
  var prizeItemsData = [],
    counter = 0;

  // loop through each quantity field
  for (var i = 0; i < prizeQuantityFields.length; i++) {
    var prizeQuantityField = prizeQuantityFields[i];

    // loop through selected quantity
    for (var n = 0; n < prizeQuantityField.value; n++) {
      // incrementally pass winning PINs along with each prize item
      buildPrizesArray(prizeItemsData, prizeQuantityField.dataset.variantId, {
        pin: pinManagement.winningPinsArray[counter],
        'Name, Line One': customLineItemOnePropertiesArray[counter],
        'Name, Line Two': customLineItemTwoPropertiesArray[counter],
      });

      // update incremental counter
      counter++;
    }
  }

  // return object for ajax call
  return prizeItemsData;
}

/*==========================================================================
    CUSTOMIZED PRIZES
  ============================================================================*/
for (var i = 0; i < customPrizeContainers.length; i++) {
  var customPrizeContainer = customPrizeContainers[i],
    prizeNumber = customPrizeContainer.getAttribute('data-custom-prize-number'),
    inputBoxOne = document.getElementById('CustomInputLineOne-' + prizeNumber),
    inputBoxTwo = document.getElementById('CustomInputLineTwo-' + prizeNumber);

  inputBoxOne.addEventListener('keyup', function () {
    checkCustomTextLength(inputBoxOne, customPrizeContainer);
  });

  inputBoxTwo.addEventListener('keyup', function () {
    checkInputOne(inputBoxOne, customPrizeContainer);
  });
}

function checkCustomTextLength(inputBoxOne, customPrizeContainer) {
  var inputBoxOneText = inputBoxOne.value,
    addButton = document.getElementById('addBlockButton'),
    previewButton = customPrizeContainer.querySelector('[data-preview-button]');

  if (inputBoxOneText.length >= 1) {
    if (addButton) {
      addButton.removeAttribute('disabled');
    }
    previewButton.removeAttribute('disabled');
    previewButton.classList.remove('disabled');
  } else {
    if (addButton) {
      addButton.setAttribute('disabled', 'disabled');
    }
    previewButton.setAttribute('disabled', 'disabled');
    previewButton.classList.add('disabled');
  }
}

function checkInputOne(inputBoxOne, customPrizeContainer) {
  var inputBoxOneText = inputBoxOne.value;
  var previewButton = customPrizeContainer.querySelector(
    '[data-preview-button]'
  );

  if (inputBoxOneText.length < 1) {
    previewButton.setAttribute('disabled', 'disabled');
    previewButton.classList.add('disabled');
  }
}
